/**
 * Shared init helper for Swiper-based marketing sections.
 *
 * Sections register a config before this (deferred) script runs by pushing to
 * `window.swiperSections`. Once loaded, we swap that array for a live registrar
 * so sections added later in the theme editor register the same way.
 *
 * Config shape: { rootId, initFlag, onInit(root) }
 */
(function () {
  // The asset is referenced by several sections; only wire things up once.
  if (window.__swiperSectionReady) return;
  window.__swiperSectionReady = true;

  // Swiper is loaded with defer elsewhere; retry until it is available.
  function whenSwiperReady(cb, attempt) {
    attempt = attempt || 0;
    if (typeof Swiper !== 'undefined') {
      cb();
    } else if (attempt < 40) {
      setTimeout(function () {
        whenSwiperReady(cb, attempt + 1);
      }, 250);
    }
  }

  function run(config) {
    var root = document.getElementById(config.rootId);
    if (!root || root.dataset[config.initFlag] === '1') return;
    root.dataset[config.initFlag] = '1';
    config.onInit(root);
  }

  function register(config) {
    whenSwiperReady(function () {
      run(config);
    });

    // Re-init when this section is reloaded in the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      var el = document.getElementById(config.rootId);
      if (el && event.target.contains(el)) {
        whenSwiperReady(function () {
          run(config);
        });
      }
    });
  }

  var queued = window.swiperSections && window.swiperSections.length ? window.swiperSections : [];
  window.swiperSections = { push: register };
  queued.forEach(register);

  /**
   * HIM/HER tab toggle shared by grouped carousels. Shows the carousel matching
   * the active tab and updates its Swiper so the layout re-measures.
   */
  window.initGroupToggle = function (root, swipers, btnSelector, carouselSelector) {
    root.querySelectorAll(btnSelector).forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll(btnSelector).forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll(carouselSelector).forEach(function (el) {
          var show = el.dataset.group === btn.dataset.group;
          el.hidden = !show;
          var sw = swipers[el.dataset.group];
          if (show && sw) {
            sw.update();
            if (sw.scrollbar && sw.scrollbar.updateSize) sw.scrollbar.updateSize();
          }
        });
      });
    });
  };
})();
